import { uniq } from 'lodash-es';
import type { FieldValueValidator } from 'models/forms/fields/utils';
import { type FieldFormatter, isHandledBySamePredicate } from 'models/forms/fields/utils';

export type AvailableStrikeModeFieldBase = {
  availableStrikeModes: string[];
};

export const availableStrikeModeFieldFormatter: FieldFormatter<AvailableStrikeModeFieldBase> = {
  areSameType: isHandledBySamePredicate(isAvailableStrikeModeField),
  isHandled: isAvailableStrikeModeField,
  merge: mergeAvailableStrikeModeField,
  withDefault: f => ({ ...f, availableStrikeModes: ['', ...f.availableStrikeModes] }),
};
export const strikeModeFieldValueValidator: FieldValueValidator<AvailableStrikeModeFieldBase, string> = {
  isHandled: isAvailableStrikeModeField,
  validateValue: (value, field) => field.availableStrikeModes.includes(value),
};
export function isAvailableStrikeModeField(val: unknown): val is AvailableStrikeModeFieldBase {
  return (val as AvailableStrikeModeFieldBase).availableStrikeModes !== undefined;
}

export function mergeAvailableStrikeModeField(
  firstField: AvailableStrikeModeFieldBase,
  secondField: AvailableStrikeModeFieldBase,
): AvailableStrikeModeFieldBase {
  return {
    ...firstField,
    availableStrikeModes: uniq([...firstField.availableStrikeModes, ...secondField.availableStrikeModes]),
  };
}
